'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var StoreContext = React__default["default"].createContext(null);
var StoreProvider = function (_a) {
    var rxStore = _a.rxStore, children = _a.children;
    return React__default["default"].createElement(StoreContext.Provider, { value: rxStore }, rxStore && children);
};

var useReactable = function (reactableFactory) {
    var props = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        props[_i - 1] = arguments[_i];
    }
    var _a = React.useMemo(function () { return reactableFactory.apply(void 0, props); }, []), state$ = _a[0], actions = _a[1], messages$ = _a[2];
    var _b = React.useState(), state = _b[0], setState = _b[1];
    React.useEffect(function () {
        var subscription = state$.subscribe(function (result) {
            setState(result);
        });
        return function () {
            // Adding setTimeout fixes the issue.
            // React Strict Mode has bugs with clean up with refs so it breaks the useReactable hook as of now
            // See Bug: https://github.com/facebook/react/issues/26315
            // See Bug: https://github.com/facebook/react/issues/24670
            setTimeout(function () {
                subscription.unsubscribe();
            }, 0);
        };
    }, [state$]);
    return [state, actions, state$, messages$];
};

var useAppStore = function () {
    var rxStore$ = React.useContext(StoreContext);
    var rxStore = useReactable(function () { return rxStore$; });
    return rxStore;
};

exports.StoreProvider = StoreProvider;
exports.useAppStore = useAppStore;
exports.useReactable = useReactable;
